import { Card } from '@populix/pop-ui'
import React from 'react'

type TPartnerAccessMessageProps = {
  partnerName?: string
}

export default function PartnerAccessMessage({
  partnerName,
}: Readonly<TPartnerAccessMessageProps>) {
  if (!partnerName) return null

  return (
    <Card noElevation>
      <div className='flex flex-col gap-4'>
        <h1 className='text-base font-bold'>
          You are accessing Responova account on {partnerName}
        </h1>
        <p className='text-sm font-normal'>
          Survey reward earnings from this account can only be accessed from {partnerName}.
        </p>
      </div>
    </Card>
  )
}
